<template>
  <div class="flex align-center inline-checkbox-outer">
    <label class="input--checkbox">
      <input type="checkbox" :checked="isChecked" v-on:change="toggle">

      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30px" height="30px" version="1.1">
        <g fill="none" fill-rule="evenodd">
          <rect x="5" y="5" width="20" height="20" rx="3"/>
          <polyline points="28 3 15.1266569 17 10 11.8756235"></polyline>
        </g>
      </svg>

      <div class="input__inline-label">
        <span v-html="label"></span>
        <span v-if="required" class="input__asterisk">*</span>
      </div>
    </label>
  </div>
</template>

<script>
  export default {
    name: 'inputCheckbox',
    props: [
      'label',
      'required',
      'value'
    ],
    data () {
      return {
        isChecked: this.value || false
      }
    },
    methods: {
      emitChangeEvents () {
        this.$emit('change', this.isChecked)
        this.$emit('input', this.isChecked)
      },
      toggle () {
        this.isChecked = !this.isChecked
        this.emitChangeEvents()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// inputCheckbox.vue?275115c0